import { render } from "./RequestDetailsCard.vue?vue&type=template&id=2e498a18"
import script from "./RequestDetailsCard.vue?vue&type=script&lang=js"
export * from "./RequestDetailsCard.vue?vue&type=script&lang=js"

import exportComponent from "/Users/onisiforosgeorgiou/WebstormProjects/AgencyNow/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__